<!-- =========================================================================================
  File Name: UserEdit.vue
  Description: User Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: ESM - EASY SCHOOL MANAGEMENT
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>
  <div class="demo-alignment">
      <vs-popup fullscreen title="Ajout d'un examen" :active.sync="objet.popupActive">
        <form data-vv-scope="Examen" @submit.prevent="Examen_validate">
          <vx-card ref="filterCard" :title="$t('exam')" class="user-list-filters mb-8" actionButtons @refresh="resetColFilters" @remove="resetColFilters">
            <div class="vx-row">
              <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
                <p class="mb-2">{{ $t('room') }} <b style="color: #ff6141">*</b></p>
                <v-select
                  :options="salles"
                  @search="getSalle"
                  :clearable="false"
                  label="libelle"
                  v-model="salle_input"
                  class="w-full"
                  name="salle" v-validate="'required'"
                />
                <span class="text-danger">{{ errors.first('Examen.salle') }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
                <p> {{ $t('partition') }}</p>
                <v-select
                  :disabled="true"
                  :reduce="rep => rep.id"
                  :options="partitions"
                  :clearable="true"
                  label="long_label"
                  v-model="partition"
                  class="w-full" name="partition" v-validate="'required'"/>
                <span class="text-danger">{{ errors.first('Examen.partition') }}</span>
              </div>
              <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
                <p class="mb-2" > Matière <b style="color: #ff6141">*</b></p>
                <v-select
                  :disabled="salle_input ? false : true"
                  :options="classeMatieres"
                  @search="getClasseMatiere" 
                  :clearable="true" 
                  :getOptionLabel="getOptionLabel"
                  v-model="classeMatiere"
                  class="w-full"
                  name="matiere" v-validate="'required'"
                />
                <span class="text-danger">{{ errors.first('Examen.matiere') }}</span>          
              </div>
              <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
                <p> {{ $t('exam_type') }} <b style="color: #ff6141">*</b> </p>
                <v-select
                  :reduce="rep => rep.id"
                  :options="typeExamens"
                  @search="getTypeExamen"
                  :clearable="true"
                  label="libelle"
                  v-model="typeExamen"
                  class="w-full" name="typeExamen" v-validate="'required'"/>
                <span class="text-danger">{{ errors.first('Examen.typeExamen') }}</span>
              </div>

              <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
                <p> {{ $t('valuation_date') }} <b style="color: #ff6141">*</b> </p>
                <datepicker
                  v-model="dateEvaluation"
                  name="dateEvaluation"
                  v-validate="'required'"
                  >
                </datepicker>
                <span class="text-danger">{{ errors.first('Examen.dateEvaluation') }}</span>
              </div>
              <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
                <p> {{ $t('start_time') }} <b style="color: #ff6141">*</b> </p>
                <flat-pickr
                  :config="configdateTimePicker"
                  v-model="heureDebut"
                  class="w-full"
                  name="heureDebut"
                  v-validate="'required'" />
                <span class="text-danger">{{ errors.first('Examen.heureDebut') }}</span>
              </div>
              <div class="vx-col lg:w-1/2 md:w-1/2 sm:w-1/2 w-full mb-2">
                <p> {{ $t('end_time') }} <b style="color: #ff6141">*</b> </p>
                <flat-pickr
                  :config="configdateTimePicker"
                  v-model="heureFin"
                  class="w-full" name="heureFin"
                  v-validate="'required'" />
                <span class="text-danger">{{ errors.first('Examen.heureFin') }}</span>
              </div>

            </div>
          </vx-card>

          <vs-list>
            <vs-list-header v-if="partition" icon-pack="feather" icon="icon-users" title="Vérification de l'existence des élèves" color="success"></vs-list-header>
            <vs-list-item
              v-if="partition"
              icon-pack="feather"
              :icon="globalVerification.partitionInscription ? 'icon-check' : 'icon-x'"
              title="Élèves inscrits dans cette matière"
              :subtitle="globalVerification.partitionInscription ? 'Existant' : 'Inexistant'">

              <div
                v-if="!globalVerification.partitionInscription"
                class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-success border border-solid border-success"
                @click="inscrireLesEleves()"
              >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-success">
                  Inscrire les élèves 
                </span>
              </div>

            </vs-list-item>

            <vs-list-header v-if="salle_input && classeMatiere" icon-pack="feather" icon="icon-user-plus" title="Vérification de l'existence du professeur"></vs-list-header>
            <vs-list-item
              v-if="salle_input && classeMatiere"
              icon-pack="feather"
              :icon="globalVerification.professeurClasseMatiere ? 'icon-check' : 'icon-x'"
              title="Professeur en charge de cette matière"
              :subtitle="globalVerification.professeurClasseMatiere ? 'Existant' : 'Inexistant'">

              <div
                v-if="!globalVerification.professeurClasseMatiere"
                class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                @click="affecterUnProfesseur()"
              >
                <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                <span class="ml-2 text-base text-primary">
                  Affecter un professeur 
                </span>
              </div>

            </vs-list-item>
          </vs-list>
          <br>

          <vs-button
            class="mt-5"
            icon-pack="feather"
            icon="icon-check"
            @click="Examen_validate()"
          >
            Valider
          </vs-button>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
          <br>
        </form>
      </vs-popup>
  </div>
</template>

<script>
import { Validator } from 'vee-validate'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Datepicker from 'vuejs-datepicker'

export default {
  components: { flatPickr, Datepicker },
  props: {
    objet: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      globalVerification: {
        professeurClasseMatiere: false,
        partitionInscription: false
      },
      paramProfesseurClasseMatiere: {
        is_get: true,
        paginate: {
          length: 150,
          page: 1
        },
        filter: {
          q_list: [],
          salle__is_active: true,
          salle__classe__is_active: true,
          salle__classe__niveau__is_active: true,
          salle__classe__niveau__niveauTypePartitions__anneeScolaire__id: this.$store.state.anneeScolaire.id,
          classeMatiere__anneeScolaire__id: this.$store.state.anneeScolaire.id
        },
        juste: {
          id: ''
        }
      },
      salle_input: '',
      salles: [],
      classeMatieres: [],
      classeMatiere: '',
      professeurClasseMatiere: '',
      typeExamens: [], 
      partitions: [], 
      typeExamen: '',
      partition: '',
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: true,
        noCalendar: true
      },
      dateEvaluation: '',
      heureDebut: '',
      heureFin: '',
      paramClasseMatiere: {
        is_get: true,
        paginate: {
          length: 500,
          page: 1
        },
        filter: {
          q_list: [],
          classe__is_active: true,
          classe__niveau__is_active: true,
          classe__niveau__niveauTypePartitions__anneeScolaire__id: this.$store.state.anneeScolaire.id,
          anneeScolaire__id: this.$store.state.anneeScolaire.id
        },
        juste: {
          id: '',
          classe: {
            id: '',
            libelle: '',
            niveau: {
              id: ''
            }
          },
          matiere: {
            libelle: ''
          }
        }
      },
      paramPartition: {
        is_get: true,
        paginate: {
          length: 150,
          page: 1
        },
        filter: {
          q_list: [],
          is_active: true
        },
        orderby: ['ordre']
      },
      paramTypeExamen: {
        is_get: true,
        paginate: {
          length: 150,
          page: 1
        },
        filter: {
          q_list: []
        }
      }
    }
  },
  watch: {
    salle_input (value) {
      if (value) {
        this.paramClasseMatiere.filter['classe__id'] = value.classe.id
        this.paramClasseMatiere.filter['anneeScolaire__id'] = this.$store.state.anneeScolaire.id
        this.paramClasseMatiere.filter['classe__niveau__niveauTypePartitions__anneeScolaire__id'] = this.$store.state.anneeScolaire.id

        this.paramPartition.filter['niveauTypePartition__anneeScolaire__id'] = this.$store.state.anneeScolaire.id
        this.paramPartition.filter['niveauTypePartition__niveau__id'] = value.classe.niveau.id
      } else {
        delete this.paramClasseMatiere.filter['classe__id']
        delete this.paramClasseMatiere.filter['anneeScolaire__id']
        delete this.paramClasseMatiere.filter['classe__niveau__niveauTypePartitions__anneeScolaire__id']

        delete this.paramPartition.filter['niveauTypePartition__anneeScolaire__id']
        delete this.paramPartition.filter['niveauTypePartition__niveau__id']
      }

      this.getPartitionSimple()
      this.getClasseMatiereSimple()
    },
    classeMatiere () {
      this.verification()
    }
  },
  methods: {
    inscrireLesEleves () {
      const routeData = this.$router.resolve({path: '/report_cards_management/student_by_partition/0'})
      window.open(routeData.href, '_blank')
    },
    affecterUnProfesseur () {
      const routeData = this.$router.resolve({path: '/report_cards_management/matter_by_teachers/0'})
      window.open(routeData.href, '_blank')
    },
    resetColFilters () {
      this.$refs.filterCard.removeRefreshAnimation()
    },
    verifyIfProfesseurClasseMatiereExist () {
      return new Promise((resolve) => {
        this.paramProfesseurClasseMatiere.filter['salle__id'] = this.salle_input.id
        this.paramProfesseurClasseMatiere.filter['classeMatiere__id'] = this.classeMatiere.id

        this.$http.post(`${this.$store.state.route_for_esm}ProfesseurClasseMatiere`, this.paramProfesseurClasseMatiere)
          .then((response) => {
            if (response.data.data.length === 1) {
              this.professeurClasseMatiere = response.data.data[0]
              resolve(true)
            } else {
              this.professeurClasseMatiere = ''
              resolve(false)
            }
          })
          .catch((error) => { 
            resolve(false)
            console.log('error: ', error)
          })
      })
    },
    verifyIfPartitionInscriptionExist () {
      return new Promise((resolve) => {
        const param = {
          is_get: true,
          paginate: {
            length: 200,
            page: 1
          },
          filter: {},
          juste: {
            id: ''
          }
        }
        param.filter['inscription__anneeScolaire__id'] = this.$store.state.anneeScolaire.id
        param.filter['inscription__salle__id'] = this.salle_input.id
        param.filter['partition__id'] = this.partition

        this.$http.post(`${this.$store.state.route_for_esm}PartitionInscription`, param)
          .then((response) => {
            if (response.data.data.length) {
              resolve(true)
            } else {
              resolve(false)
            }
          })
          .catch((error) => { 
            resolve(false)
            console.log('error: ', error)
          })
      })
    },
    verification () {
      this.verifyIfProfesseurClasseMatiereExist()
        .then(rep => {
          this.globalVerification.professeurClasseMatiere = rep
          this.verifyIfPartitionInscriptionExist()
            .then(rep1 => {
              this.globalVerification.partitionInscription = rep1
            })
        })
    },
    submitData () {
      const input = {
        professeurClasseMatiere: this.professeurClasseMatiere.id,
        partition: this.partition,
        typeExamen: this.typeExamen,
        dateEvaluation: this.dateEvaluation,
        heureDebut: this.heureDebut,
        heureFin: this.heureFin,
        nonEffectuer: true
      }

      this.$http.post(`${this.$store.state.route_for_esm}Examen`, input)
        .then((response) => {
          window.getESM.success(this.$t('The_Exam_is_added_successfully'), response)
          this.$vs.loading.close()
          this.objet.popupActive = false
        })
        .catch((error) => {
          this.$vs.loading.close()
          console.log('error: ', error)
        })
    },
    Examen_validate () {
      this.$validator.validateAll('Examen').then(result => {
        if (result) {
          if (this.globalVerification.professeurClasseMatiere && this.globalVerification.partitionInscription) {
            this.submitData()
          }
        }
      })
    },
    getOptionLabel (option) {
      if (typeof option === 'object') {

        return `${option.matiere.libelle}`
      }
      return option
    },
    getClasseMatiereSimple () {
      delete this.paramClasseMatiere.filter['matiere__libelle__icontains']
      this.$http.post(`${this.$store.state.route_for_esm}ClasseMatiere`, this.paramClasseMatiere)
        .then((response) => {
          this.classeMatieres = JSON.parse(JSON.stringify(response.data.data))

          console.log('response: ', response)
          console.log('this.paramClasseMatiere: ', this.paramClasseMatiere)
        })
        .catch((error) => { 
          console.log('error: ', error)
        })
    },
    getClasseMatiere (search, loading) {
      loading(true)
      this.paramClasseMatiere.filter['matiere__libelle__icontains'] = search
      this.$http.post(`${this.$store.state.route_for_esm}ClasseMatiere`, this.paramClasseMatiere)
        .then((response) => {
          this.classeMatieres = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => { 
          loading(false)
          console.log('error: ', error)
        })
    },
    getSalleSimple () {
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          classe__is_active: true,
          classe__niveau__is_active: true,
          classe__classeMatieres__isnull: false
        },
        juste: {
          id: '',
          libelle: '',
          classe: {
            id: '',
            niveau: {
              id: ''
            }
          }
        },
        orderby: ['classe__ordre', 'ordre'],
        exclude: { code: 'Attente' }
      }
      this.$http
        .post(`${this.$store.state.route_for_esm}Salle`, data)
        .then((response) => {
          this.salles = response.data.data
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getSalle (search, loading) {
      loading(true)
      const data = {
        is_get: true,
        paginate: {
          length: 50,
          page: 1
        },
        filter: {
          is_active: true,
          classe__is_active: true,
          classe__niveau__is_active: true,
          classe__classeMatieres__isnull: false,
          libelle__icontains: search
        },
        juste: {
          id: '',
          libelle: '',
          classe: {
            id: '',
            niveau: {
              id: ''
            }
          }
        },
        orderby: ['classe__ordre', 'ordre'],
        exclude: { code: 'Attente' }
      }
      this.$http
        .post(`${this.$store.state.route_for_esm}Salle`, data)
        .then((response) => {
          this.salles = response.data.data
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getTypeExamenSimple () {
      delete this.paramTypeExamen.filter['libelle__icontains']
      this.$http.post(`${this.$store.state.route_for_esm}TypeExamen`, this.paramTypeExamen)
        .then((response) => {
          this.typeExamens = JSON.parse(JSON.stringify(response.data.data))
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    getTypeExamen (search, loading) {
      loading(true)
      this.paramTypeExamen.filter['libelle__icontains'] = search
      this.$http.post(`${this.$store.state.route_for_esm}TypeExamen`, this.paramTypeExamen)
        .then((response) => {
          this.typeExamens = JSON.parse(JSON.stringify(response.data.data))
          loading(false)
        })
        .catch((error) => {
          loading(false)
          console.log('error: ', error)
        })
    },
    getPartitionSimple () {
      delete this.paramPartition.filter['long_label__icontains']
      this.$http.post(`${this.$store.state.route_for_esm}Partition`, this.paramPartition)
        .then((response) => {
          this.initInputPartition(response.data.data)
          this.partitions = JSON.parse(JSON.stringify(response.data.data))

          this.verification()
        })
        .catch((error) => {
          console.log('error: ', error)
        })
    },
    initInputPartition (partitions) {
      if (partitions.length === 1) {
        this.partition = partitions[0].id
      }
    },
    initValues () {
      this.$validator.errors.clear()
    }
  },
  created () {
    this.getTypeExamenSimple()
    this.getSalleSimple()

    const dict = {
      custom: {
        professeurClasseMatiere: {
          required: this.$t('The_matter_by_teachers_is_required')
        },
        inscription: {
          required: this.$t('The_Student_is_required')
        },
        typeExamen: {
          required: this.$t('The_type_examen_is_required')
        },
        matiere: {
          required: this.$t('The_matter_is_required')
        },
        salle: {
          required: this.$t('The_room_is_required')
        },
        partition: {
          required: this.$t('The_partition_is_required')
        },
        dateEvaluation: {
          required: this.$t('The_valuation_date_is_required')
        },
        heureDebut: {
          required: this.$t('The_start_time_is_required')
        },
        heureFin: {
          required: this.$t('The_end_time_is_required')
        }
      }
    }
    Validator.localize('en', dict)
  }
}
</script>

<style>
[dir] .vs__dropdown-toggle {
  border-radius: 20px;
}

[dir] .flatpickr-input, [dir] .flatpickr-input[type="hidden"] + input {
  border-radius: 20px;
}

[dir] .vdp-datepicker input {
  border-radius: 20px;
}
</style>
